import React from 'react';
import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';
import { motion } from "framer-motion";
import { NavLink } from 'react-router-dom';

function App() {
  return (
    <>
      <motion.div className="page" key="loading" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
          <div className="page-container">
            <div className="page-boxes">

              <div className="cesta-seznam cesta-seznam-kol">
                <NavLink to="/#kola"><button><span>KOLA</span></button></NavLink>
                <button className="cesta-active"><span>LOADING</span></button>
              </div>

              <h1 className="bike-seznam-loading">Načítání</h1>
              <h2 className="bike-seznam-loading-text">Načítání</h2>
              <div className="page-boxes-container">
                    <NavLink>
                      <div className="pages-bikes pages-bikes-loading" />
                    </NavLink>
                    <NavLink>
                      <div className="pages-bikes pages-bikes-loading" />
                    </NavLink>
                    <NavLink>
                      <div className="pages-bikes pages-bikes-loading" />
                    </NavLink>
              </div>
            </div>
          </div>
      </motion.div>
    </>
  );
}

export default App;